import { CommonBrickSettingsStateModel } from './common-brick-settings.state';
import { CommonBrickSettingRemoteDto } from '../../../../../../generated/signalR/common-brick-setting-remote-dto';
import _ from 'lodash';

export function getBrickSettingModel(
   state: CommonBrickSettingsStateModel,
   brickId: string,
   getDefaultIfNotAvailable: boolean = true,
   ignoreEditModeValues: boolean = false
): CommonBrickSettingRemoteDto {
   let brickSettingModel: CommonBrickSettingRemoteDto;
   if (_.isNil(state.brickSettingsEditMode) || ignoreEditModeValues) {
      brickSettingModel = state.brickSettings[brickId];
   } else {
      brickSettingModel = state.brickSettingsEditMode[brickId];
   }
   if (_.isNil(brickSettingModel) && getDefaultIfNotAvailable) {
      brickSettingModel = {
         brickOverwrittenTitle: null,
         brickScaling: 100,
      };
   }
   return brickSettingModel;
}
